module.exports = __webpack_public_path__ + "f94400a244ceab663e8abf865f0fd458.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/as.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/as.svg
// module chunks = 0